<template>
  <div class="list-deals-page">
    <DealsTable :title="$t('MENU.ASIDE.DEALS_LIST')" />
  </div>
</template>

<script>
import DealsTable from "@/views/partials/deals/DealsTable.vue";

export default {
  name: "ListDeals",
  components: {
    DealsTable,
  },
};
</script>

<style scoped>
.list-deals-page {
  max-width: 100%;
}
</style>
